import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getForumTopics = (pageNum, pageSize) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.SOCIAL.FORUM_AREA.FORUM_TOPICS(pageNum, pageSize)
  );
};

export default getForumTopics;
